export default {
    cart: {
      account: '結算'
    },
    msg:{
      hello: 'hello world'
    },
    message:{
      hello:'hello <br/> world',
      hi:'%{msg} world'
    },
    en: {
      apple: 'no apples | one apple | {count} apples',
      banana: 'no bananas | {n} banana | {n} bananas'
    },
    tips: {
      cart_success: "Telah berjaya ditambahkan ke troli beli-belah",
      add_success: "Berjaya ditambahkan",
      empty: "Kosong~",
      order_success: "Tahniah, pesanan berjaya dihantar",
      chose: "Sila pilih",
      un_pay_on_line: "Buat masa ini tidak menyokong pembayaran dalam talian",
      area_not_empty: "Wilayah tidak boleh kosong",
      name_not_empty: "Nama tidak boleh kosong",
      address_not_empty: "Alamat tidak boleh kosong",
      phone_not_empty: "Nombor telefon tidak betul"
    },
    detail: {
      Delivery_method:'Kaedah penghantaran',
      Delivery_information:'Maklumat penghantaran',
      CloseOrder:'Pesanan lengkap',
      carriage: 'Pengangkutan',
      Subtotal:'Jumlah keseluruhan',
      Total:'Jumlah',
      jian:'Kepingan',
      mange:'pengurusan',
      surplus: 'Kekal',
      goods_detail: 'Maklumat produk',
      cart: 'kereta',
      add_cart: 'Tambah ke troli',
      buy_now: 'Beli sekarang',
      paypaly_method:'Cara bayaran',
      paypaly1:'Tunai semasa penghantaran',
      paypaly2:'Pembayaran',
      paypalyOut:'Dalam perkembangan ， tunggu dengan sabar pls.'
    },
    order: {
      freeFreight:'Bebas',
      allTotal:'Jumlah harga barang',
      query:'Perintah penyelidikan',
      goods_info: 'Maklumat produk',
      pay_way: 'Pilih kaedah penghantaran dan pembayaran',
      offline: 'Tunai semasa penghantaran',
      online: 'Pembayaran dalam talian',
      pick_info: 'Maklumat penghantaran',
      name_name: 'Nama',
      name: 'Nama penerima',
      phone_name: 'Telefon',
      phone: 'Nombor telefon bimbit penerima',
      area: 'Wilayah, bandar, daerah, dll.',
      region: 'Wilayah',
      address_name: 'Alamat terperinci',
      address: 'Nombor jalan, nombor bilik lantai dan maklumat lain',
      offer_order: 'Hantar pesanan',
    },
    data: {
      Recipient_name:'Nama penerima',
      Recipient_nameTips:'Isikan nama sebenar penerima untuk memastikan penerimaan yang lancar',
      Select_M:'Pilih kedai',
      email:'Peti surat penerima',
      Select_M_number:'Nombor kedai terpilih',
      Selected_store_name:'Nama kedai terpilih',
      Shop_address:'Alamat kedai',
      address:'Sila pilih alamat',
      Choose_payment_method:'Kaedah pembayaran terpilih',
      default_address:'Taiwan',
    },
    indexdata:{
      index:'Rumah',
      list:'Senaraikan',
      placeholder:'Sila masukkan kata kunci carian',
      Return:'Kembali'
    },
    Product_details_page: {
      guarantee:'Jaminan',
      guarantee_texts: 'Jaminan kesahihan || Salah satu hingga kehilangan empat || Bayaran balik cepat',
      numbertext:'Kuantiti',
      Select_product_specification:'Pilih spesifikasi produk',
      Package_selection: 'Pemilihan pakej',
      Buy_now: 'Beli sekarang'
    },
    newOrder:{
      Order_information:'Maklumat pesanan',
      Selection_of_delivery_and_payment_methods:'Pilih kaedah penghantaran dan pembayaran',
      Delivery_place:'Lokasi penghantaran',
      tw:'Taiwan',
      Delivery_method:'Kaedah penghantaran',
      Sub_total:'Jumlah keseluruhan',
      Freight_charges:'Pengangkutan',
      Total:'Jumlah',
      Go_to_checkout:'Pergi ke daftar keluar',
    },
    order3: {
      Total:'Jumlah  RM',
      Delivery_information:'Maklumat penghantaran',
      Freight_charges:'Pengangkutan',
      change:'Tukar',
      Search_shop:'Cari kedai',
      Order_notes:'Nota pesanan',
      Payment_information:'Maklumat pembayaran',
      Payment_method_selected:'Kaedah pembayaran yang dipilih',
      Submit_order: 'Hantar pesanan',
      xxdz:'Sila masukkan alamat terperinci',
      Select_address: 'Sila pilih alamat',
      Tell_the_seller:'Adakah anda ingin memberitahu penjual?',
      freight:"Pengangkutan:",
      Spesifikasi_jualan_pendek:'Spesifikasi habis dijual'
    },
    index:{
      placeholder:'Sila masukkan kata kunci carian',
      index:'Rumah',
      list: 'Senarai',
      language:'Pilih bahasa'
    },
    Guarantee:{
      num:'nombor',
      Pickup_method:'Sokongan 7-11, Pengambilan Pedagang Super Keluarga',
      Guarantee:'Jaminan kualiti',
      Freight:'penghantaran percuma',
      Commodity_pic:'Gambar komoditi',
      Options:'Pilihan',
      selected:'terpilih',
      Total_price:'Jumlah harga pesanan',
      Finally_cope:'Akhirnya mengatasi',
      message:'tinggalkan pesanan',
      region:'Daerah/Bandar',
      region_s:'Bandar/Perbandaran/Daerah',
      country:'negara/wilayah'
    },
    Pay:{
      language:'Tunai semasa penghantaran',
      money:'RM',
      to:'Lompat ke laman utama dalam beberapa saat',
      postcode:'Poskod',
      setMeal:'Harga pakej gabungan',
      success:'berjaya dipesan!',
      time:'Pedagang akan mengesahkan pesanan anda secara automatik dalam masa 10 minit!',
      realMoney:'Jumlah yang sebenarnya dibayar',
      orderNumber:'Nombor pesanan',
      waitFor:'Pedagang tidak menghantar, sila tunggu dengan sabar'
    },
    comment:{
      comment:'Hantarkan komen',
      Praise:'Puji',
      Average:'Rata-rata',
      Badreview:'Ulasan buruk',
      submitcomments:'Sila masukkan komen',
      PleaseEnteraComment:'Sila masukkan komen'
    },
    Toast:{
      inputName:'Sila masukkan nama',
      inputPhone:'Sila masukkan nombor telefon',
      inputZip:'Sila masukkan poskod',
      inputAddress:'Sila masukkan alamat terperinci',
      inputAlertAddress:'Alamat tidak dihantar, sila ubah ke alamat lain',
    },
    contactUs:{
      callMe:'To learn more <br>,Pls contact the Messenger of our Facebook page!',
      afterShop:`Already shopping,Pls contact us: <br> Email: <a href='mailto:service325@hotmail.com'>service325@hotmail.com</a>`,
      confirm:'OK',
      shortSale:'Spesifikasi telah dijual',
    },
    ensure:{
      introduce:'Perkenalan produk',
      Specifications:'Spesifikasi komoditi',
      ensure:'Garansi bahan-bahan',
      di:'',
      commodity:'th item'
    },
    wuliu:{
      orderSearch:'订单查询',
      provide:'本數據由物流官方提供',
      OrderOrLogistics:'訂單號/物流單號(填寫一項即可查詢)',
      orderPlaceho:'填寫相關訊息查詢',
      query:'查询订单号',
      Tips:'温馨提示',
      Tipsinfo:'收到商品後有任何疑問請聯繫在線客服或發郵件至service325@hotmail.com。同時請告知您的姓名/聯繫方式/訂單編號，我們會快速的給您及時處理，祝您購物愉快！',
    }
  }
  


// WEBPACK FOOTER //
// ./src/i18n/ma.js